let origin = window.ORIGIN;
//管家列表
const getButlerListUrl = `${origin}/gateway/hc-neighbour/butler/getButlerInfoByHouseId`;

//获取管家评价
const getButlerCommentListURL = `${origin}/gateway/hc-neighbour/butler/getButlerEvaluateList`;
//管家评价
const commentListURL = `${origin}/gateway/hc-neighbour/butler/addButlerEvaluateRecord`;
export { getButlerListUrl, getButlerCommentListURL, commentListURL };
